import { createPortal } from "react-dom";
import { X } from "@phosphor-icons/react";
import SponsorGateCard from "./SponsorGateCard";

/**
 * The window that holds the sponsor gate (blurred page behind, ad, locked Download).
 *
 * On its own it is portalled into <body>. When it is opened from the character drawer
 * (a Radix dialog) it is rendered INSIDE the drawer instead (`portal={false}`): the
 * drawer blocks every tap and scroll aimed at anything outside itself, so a gate placed
 * outside could never be pressed or scrolled.
 */
export default function DownloadGateModal({ gate, onDownload, onClose, portal = true }) {
  const node = (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-3 md:p-8 sponsor-gate-in"
      // a Radix dialog turns pointer events off for the rest of the page — switch them back on here
      style={{ pointerEvents: "auto" }}
      data-testid="sponsor-gate-modal"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/70 backdrop-blur-xl" />
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-3xl max-h-[92vh] max-h-[92dvh] overflow-y-auto overscroll-contain rounded-2xl border border-white/10 bg-[#141414] shadow-[0_40px_120px_-20px_rgba(0,0,0,0.9)] sponsor-gate-card"
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          data-testid="sponsor-gate-close"
          className="absolute top-4 right-4 z-20 w-9 h-9 rounded-full bg-black/50 hover:bg-[#880015] backdrop-blur flex items-center justify-center text-white transition"
        >
          <X size={16} weight="bold" />
        </button>
        <SponsorGateCard
          ad={gate.ad}
          pack={gate.pack}
          minSeconds={gate.minSeconds}
          onDownload={onDownload}
          onCloseGate={onClose}
          stickyFooter
        />
      </div>
    </div>
  );
  return portal ? createPortal(node, document.body) : node;
}
